import { Component, OnInit } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import {
  FormGroup
  , FormControl
  , Validators
  , FormBuilder
} from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { CookieService } from 'ngx-cookie-service';
import { reCaptchaSiteKey } from 'src/app/config';
import { NgxSpinnerService } from 'ngx-spinner';
import { PasswordForgotComponent } from '../shared/popups/password-forgot/password-forgot.component';
import { ReCaptchaComponent } from '../shared/popups/re-captcha/re-captcha.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  // ischeck=false;
  LoginDetails: FormGroup;
  siteKey = reCaptchaSiteKey;
  googleToken: string;
  hide = true;
  reCaptcha;
  action: string;
  constructor(
    private router: Router
    , private formBuilder: FormBuilder
    , private _api: ApiService
    , private cookieService: CookieService
    , private spinner: NgxSpinnerService
    , public dialog: MatDialog
    , private route: ActivatedRoute
  ) {
    this.LoginDetails = this.formBuilder.group({
      user_email: new FormControl('', [Validators.required, Validators.email]),
      user_password: new FormControl('', [Validators.required]),
      // recaptcha: [''],
      ischeck: new FormControl(false, [])
    });
  }

  ngOnInit() {
    localStorage.removeItem('expiry');
    sessionStorage.removeItem('token');
    this.isValidToken();
    this.getActionByUrl();
  }
  getActionByUrl() {
    this.route.queryParamMap.subscribe(paramsdata => {
      const action = paramsdata['params']['action'];

      if (action) {
        this.action = action;
        switch (action) {
          case 'passwordReset':
            break;
          default:
            break;
        }
      }
    });
  }
  initForgotPwd(msg) {
    const data = {
      title: 'Reset Password'
      , type: 'forgot_password'
      , email: this.LoginDetails.get('user_email').value
      , pwdresetMsg: msg
    };
    this.openDialog(data);
  }
  forgotPwd() {
    const data = { title: 'Forgot Password', type: 'forgot_password' };
    this.openDialog(data);
  }
  openDialog(data): void {
    const dialogRef = this.dialog.open(PasswordForgotComponent, {
      data, width: '400px',
    });
  }
  isValidToken() {
     if (this.cookieService.get('token')) {
      this._api.functionPOST('user/getApprovedBusinessCount', {}).subscribe((res) => {
        if (!res['data']['email_verified']) {
           this.router.navigate(['/']);
          this.cookieService.deleteAll('/');
          return;
        }
        // if (!res['data']['idme_verified']) {
        //   this.router.navigate(['/verification']);
        //   return;
        // }
        // if (!res['data']['membership_active']) {
        //   this.router.navigate(['/pending_approval']);
        // } else {
           if (!res['data']['membership_active']) {
          this.router.navigate(['/current_business']);
        } else {
          
          if (res['data']['no_allowedBusinesses'] > 0) {
            if (this.action === 'passwordReset') {
              this.router.navigate(['/dashboard/Security_Settings']);
            } else {
              this.router.navigate(['/dashboard/task-management']);
            }
          } else {
            if (this.action === 'passwordReset') {
              this.router.navigate(['/current_business/Security_Settings']);
            } else {
              this.router.navigate(['/current_business']);
            }
          }
        }
      });
    }
  }
  Login() {
    this._api.isOpen =  false;
    this.cookieService.deleteAll('/');
    this._api.deleteAllCookies();
    if (!this.LoginDetails.valid) { return; }
    const data = {
      email: this.LoginDetails.get('user_email').value,
      password: this.LoginDetails.get('user_password').value,
      captchaToken: this.googleToken
    };
    // this.spinner.show();
    this._api.functionPOST('user/login', data).subscribe((res) => {
       if (res['success']) {
        this.cookieService.set('token', res['data']['token'], 0, '/',
          null,
          null, 'Lax');
          // sessionStorage.setItem('token', res['data']['token']);
        if (res['data']['expireNotification']) {
          localStorage.setItem('expiry', res['data']['expireNotification_message']);
        }
        if (res['data']['code'] === 450) {
          if (this.action) {
            this.router.navigate(['/two_factor_authentication'], {queryParams: {'action': this.action}});
          } else {
            this.router.navigate(['/two_factor_authentication']);
          }
          return;
        }
        if (res['data']['agreementNotification']) {
          if (this.action) {
            this.router.navigate(['/terms-and-conditions'], {queryParams: {'action': this.action}});
          } else {
            this.router.navigate(['/terms-and-conditions']);
          }
          return;
        }
        // if (!res['data']['idme_pass']) {
        //   this.router.navigate(['/verification']);
        //   return;
        // }
        // if (res['data']['kyc_pending'] && res['data']['idme_pass']) {
        //   this.router.navigate(['/pending_approval']);
        //   return;
        // }
        if (res['data']['kyc_pending']) {
          this.router.navigate(['/current_business']);
          return;
        } 
        if (res['data']['isRestrictedUser']) {
          this.router.navigate(['/current_business/profile']);
          return;
        }
        if (res['data']['no_allowedBusinesses'] === 0) {
          if (this.action === 'passwordReset') {
            this.router.navigate(['/current_business/Security_Settings']);
          } else {
            this.router.navigate(['/current_business']);
          }
          return;
        }
        if (!res['data']['kyc_pending'] &&
          // res['data']['idme_pass'] &&
          res['data']['no_allowedBusinesses'] !== 0) {
          // this.getExpiry();
          // if (res['data']['expireNotification']) {
          //   localStorage.setItem('expiry', res['data']['expireNotification_message']);
          // }
          if(!res['data']['kyc_pending']){
            if (res['data']['membership_active']) {
              if (res['data']['no_allowedBusinesses'] > 0) { 
                this.router.navigate(['/dashboard/task-management']);
              }else{
                this.router.navigate(['/current_business']);
              }
            }else{
              this.router.navigate(['/current_business']);
            }
            return;
          }
          if (this.action === 'passwordReset') {
            this.router.navigate(['/dashboard/Security_Settings']);
          } else {
            this.router.navigate(['/dashboard/task-management']);
          }
        }
      }

    },
      err => {
        if (err['code'] && err['code'] === 452) {
          this.openCaptcha();
        } else {
          if (err['error']['passwordExpired']) {
            this.initForgotPwd(err['error']['message']);
          } else {
            this._api.openSnackBar(err['error']['message'], 'Error');
          }
        }

        this.spinner.hide();
      });
  }
  getExpiry() {
    this._api.functionGET('user/passwordNotification').subscribe((response) => {
      if (this.action === 'passwordReset') {
        this.router.navigate(['/dashboard/Security_Settings']);
      } else {
        this.router.navigate(['/dashboard/task-management']);
      }
    }, error => {

      if (error['code'] === 453) {
        localStorage.setItem('expiry', error['error']);
      }
      if (this.action === 'passwordReset') {
        this.router.navigate(['/dashboard/Security_Settings']);
      } else {
        this.router.navigate(['/dashboard/task-management']);
      }
    }

    );
  }
  openCaptcha(): void {
    const dialogRef = this.dialog.open(ReCaptchaComponent, {
      width: '400px',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.googleToken = result;
        this.Login();
      }
    });
  }
  handleSuccess($event) {

    this.googleToken = $event;
    this.LoginDetails.markAsTouched();
    this.LoginDetails.updateValueAndValidity();
  }
}
